import * as yup from 'yup';
import { notFutureDate } from 'utils/yupExtensions';
import {
  OdpMonitoringReason,
  OdpMonitoringResult,
  OdpMonitoringStage,
  OdpNextMonitoringDate,
} from 'api';
import {
  VALID_ODP_MONITORING_REASONS,
  VALID_ODP_MONITORING_RESULTS,
  VALID_ODP_MONITORING_STAGES,
} from './odpMonitoringOptions';

export const odpMonitoringValidation = yup.object({
  date: notFutureDate().required('Monitoring date is required'),
  reason: yup
    .mixed<OdpMonitoringReason>()
    .oneOf(VALID_ODP_MONITORING_REASONS)
    .required('Reason for monitoring is required'),
  result: yup
    .mixed<OdpMonitoringResult>()
    .oneOf(VALID_ODP_MONITORING_RESULTS)
    .required('Monitoring result is required'),
  stage: yup
    .mixed<OdpMonitoringStage>()
    .oneOf(VALID_ODP_MONITORING_STAGES)
    .required('Monitoring stage is required'),
  comment: yup.string().nullable().max(250, 'Comment must be 250 characters or less').default(''),
  nextMonitoringDateType: yup
    .mixed<'system' | 'manual'>()
    .oneOf(['system', 'manual'])
    .default('system'),
  customNextMonitoringDate: yup
    .mixed<OdpNextMonitoringDate>()
    .nullable()
    .default(null)
    .when('nextMonitoringDateType', {
      is: 'manual',
      then: (schema) => schema.required('Custom next monitoring date is required'),
    }),
});

export type OdpMonitoringFormData = yup.InferType<typeof odpMonitoringValidation>;
